import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';

const DATA = {
  hero: {
    label: 'NFT Credential Verification',
    title: 'Portable, verified proof of candidate skills',
    subtitle: 'CHIRE NFT tokens give candidates a blockchain-anchored record of their assessments, interviews, and verification \u2014 shareable with any recruiter, verifiable by anyone.',
    gradient: 'linear-gradient(150deg, #0076A3 0%, #312E81 50%, #5B21B6 100%)',
  },
  sections: [
    {
      label: 'Token Anatomy',
      title: 'What\'s inside a CHIRE credential token',
      features: [
        { icon: '\ud83d\udcca', title: 'Screening Score', desc: 'Resume match score (0-100), fit recommendation, matched skills, missing skills \u2014 all from the AI screening phase.' },
        { icon: '\ud83d\udcdd', title: 'Assessment Results', desc: 'Assessment percentage, points scored, per-skill breakdown bars, overall assessment rating, and integrity risk level.' },
        { icon: '\ud83c\udfa5', title: 'Interview Ratings', desc: 'Overall score, communication rating, technical depth, cultural fit, AI recommendation (Advance/Consider/Pass).' },
        { icon: '\u2705', title: 'Verification Status', desc: 'Background clearance status (Cleared/Pending/Blocked), number of documents submitted and validated.' },
        { icon: '\u26d3\ufe0f', title: 'Blockchain Proof', desc: 'Transaction hash, block number, confirmations, contract address \u2014 cryptographic proof that the credential is authentic.' },
        { icon: '\ud83c\udfc5', title: 'Readiness Badge', desc: 'Visual indicator: Fully Verified (4/4 stages complete), Partially Verified, or Initial \u2014 instant trust signal for recruiters.' },
      ],
      columns: 3,
    },
    {
      label: 'Verification Flow',
      title: 'Anyone can verify \u2014 no account needed',
      desc: 'When a candidate shares their credential link, the recipient sees a beautiful verification page with score rings, detailed breakdowns, and blockchain proof. No CHIRE login required.',
      bullets: [
        'Candidate shares link via email, LinkedIn, or job application',
        'Recruiter clicks link \u2192 sees full credential card',
        '4 score rings: Screening, Assessment, Interview, Verification',
        'Expandable detail sections for each stage',
        'On-chain verification block with TX hash and confirmations',
        'Share Link button to forward to other stakeholders',
      ],
      visual: '\ud83d\udd0d',
      visualLabel: 'Public Verification Page',
    },
    {
      label: 'Future-Ready',
      title: 'Built for the decentralized hiring future',
      desc: 'Currently running on CHIRE\'s simulated chain for instant, zero-cost issuance. Architecture is ready to deploy to Polygon, Ethereum, or Solana when you\'re ready to go fully on-chain.',
      bullets: [
        'Simulated blockchain for MVP \u2014 no gas fees, instant minting',
        'Production-ready data structures for ERC-721 NFT standard',
        'Upgradeable to Polygon (low cost) or Ethereum (maximum recognition)',
        'Wallet-to-wallet transfer support planned',
        'IPFS metadata storage for permanent credential records',
      ],
      visual: '\ud83d\ude80',
      visualLabel: 'Multi-Chain Ready Architecture',
    },
  ],
  testimonial: {
    quote: 'I shared my CHIRE credential with three companies and got interviews at all of them without re-taking any assessments. It\'s like a verified skills passport.',
    name: 'Marcus T.',
    role: 'Senior Developer, Credential Holder',
  },
  cta: {
    title: 'Give candidates credentials they can own',
    desc: 'Issue blockchain-verified credential tokens. Candidates share, recruiters verify \u2014 instantly.',
  },
};

export default function NFTCredentialsPage() { return <ProductPageTemplate data={DATA} />; }
